export class KvsRideAnimal {
  checked_in: boolean;
  country_code: string;
  date_of_birth: string;
  date_of_birth_mutation: string;
  earmark: string;
  gender_correct: boolean;
  gender_name: string;
  gender_id: number;
  hair_color_correct: boolean;
  hair_color_name: string;
  hair_color_id: number;
  health_check: boolean;
  id: number;
  kvs_approved: boolean;
  kvs_error_code: string;
  kvs_error_message: string;
  kvs_ride_id: number;
  kvs_success: string;
  loading_date: string;
  memo: string;
  origin_ubn: string;
  purchase_scan: boolean;
  rvo_check: boolean;
  scanned_earmark: string;
  weight: string;
  weight_check: boolean;
  work_number: string;
}
